const OUT_OF_DATE_ERROR_CODES = new Set(['NOT_FOUND', 'FORBIDDEN', 'CONFLICT']);

export function isContractOutOfDate(error: { data?: { code: string } | null }): boolean {
  return error.data != null && OUT_OF_DATE_ERROR_CODES.has(error.data.code);
}
